import { fmtTL, fmtNum } from "../../lib/format";
import { usageTone, matrixTotals } from "./limitRiskConst";

const Box = ({ label, value, cls = "", testid }) => <div className="min-w-[150px]"><div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">{label}</div><div className={`text-sm font-mono font-semibold ${cls}`} data-testid={testid}>{value}</div></div>;

// Form üst özeti: NAKİT / GAYRİ NAKİT / GENEL satırları → Toplam Limit · Toplam Risk · Kalan Limit (+ doluluk), matrislerden canlı hesaplanır
export default function LrFormTotals({ rows, order }) {
  const L = matrixTotals(rows, "limit", order), R = matrixTotals(rows, "risk", order);
  const lines = [["nakdi", "Nakit", L.nakdi, R.nakdi], ["gayrinakdi", "Gayri Nakit", L.gayrinakdi, R.gayrinakdi], ["total", "Genel", L.total, R.total]];
  return (
    <div className="rounded-md border border-slate-200 bg-slate-50/70 divide-y divide-slate-200" data-testid="lr-form-totals">
      {lines.map(([k, label, l, r]) => {
        const rem = l - r, pct = l ? (r / l) * 100 : null;
        return (
          <div key={k} className={`flex items-center gap-6 px-3 py-2 flex-wrap ${k === "total" ? "bg-amber-50/60" : ""}`} data-testid={`lr-form-totals-${k}`}>
            <span className={`w-24 text-[11px] font-bold uppercase tracking-wide ${k === "total" ? "text-amber-900" : "text-slate-700"}`}>{label}</span>
            <Box label={`Toplam ${label} Limit`} value={fmtTL(l)} testid={`lr-form-limit-${k}`} />
            <Box label={`Toplam ${label} Risk`} value={fmtTL(r)} testid={`lr-form-risk-${k}`} />
            <Box label={`Kalan ${label} Limit`} value={<>{fmtTL(rem)}{pct != null && <span className={`ml-1 text-[11px] font-sans font-normal ${usageTone(pct)}`}>(%{fmtNum(pct, 1)} dolu)</span>}</>} cls={rem < 0 ? "text-red-700" : "text-emerald-700"} testid={`lr-form-remaining-${k}`} />
          </div>
        );
      })}
    </div>
  );
}
